// @ts-nocheck

import React, { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getEventDetails } from 'Redux/selectors/influencer'
import { Desktop } from 'Shared/components/Responsive'
import { GreenBtn } from 'Stories/Button/Button.stories'
import {
  IconTikTok,
  StarGreyIcon,
  StarYellowIcon,
} from 'Stories/Icon/Icon.stories'
import { Container, ButtonsGroups } from '../styles'
import { Title, RatingWrapper, StyledButton, Text } from './styles'

import { CompleteProps } from './types'

const renderRating = (rating: number): JSX.Element[] => {
  const ratingArray = Array.from({ length: 5 })
  for (let i = 0; i !== +rating; i += 1) {
    ratingArray[i] = true
  }
  return ratingArray?.map(el => (el ? <StarYellowIcon /> : <StarGreyIcon />))
}

export const Complete: FunctionComponent<CompleteProps> = ({ t, onClose }) => {
  const eventDetails = useSelector(getEventDetails)
  const stars = renderRating(eventDetails?.stars || 0)

  return (
    <>
      <Container>
        <div>
          <Title>{t('influencer.yourRate')}</Title>
          <RatingWrapper>{stars}</RatingWrapper>
        </div>
        <div>
          <Title>{t('influencer.feedback')}</Title>
          <Text>{eventDetails?.feedback}</Text>
        </div>

        <ButtonsGroups>
          <Desktop>
            <GreenBtn color="white" onClick={onClose}>
              {t('influencer.closeBtn')}
            </GreenBtn>
          </Desktop>
          <Link
            to={{
              pathname: eventDetails?.tiktokVideoUrl,
            }}
            target="_blank"
          >
            <StyledButton color="whiteGreen">
              <IconTikTok />
              {t('influencer.videoOnTiktok')}
            </StyledButton>
          </Link>
        </ButtonsGroups>
      </Container>
    </>
  )
}
